'use strict';

module.exports = {
  getInterface: function(obj, commands) {
    if (!obj.__interfase) {
      var dict = {};
      for (var i = 0, l = commands.length; i < l; i++) {
        dict[commands[i]] = true;
      }

      obj.__interfase = function(method, var_args) {
        if (method) {
          var args = Array.prototype.slice.call(arguments, 1);
          return obj[method].apply(obj, args);
        }
        throw new Error('Undefined method ' + method);
      };
    }
    return obj.__interfase;
  }
};



//////////////////
// WEBPACK FOOTER
// ./lib/interfase.js
// module id = 2
// module chunks = 1 3